<template>
    <div class="dropdown d-inline-block"
        :class="`drop${direction}`">
        <div @click.stop="toggle()">
            <slot name="toggle" :isOpen="isOpen"></slot>
        </div>
        <transition name="dropdown">
            <div v-if="isOpen" class="dropdown-menu show" :class="`dropdown-menu-${align}`" aria-labelledby="dropdownMenuButton">
                <slot :toggle="toggle" :isOpen="isOpen"></slot>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        align: {
            type: String,
            default: 'left'
        },
        direction: {
            type: String,
            default: 'down'
        }
    },

    data() {
        return {
            isOpen: false,
        }
    },

    mounted() {
        document.addEventListener('click', this.globalClickHandler);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.globalClickHandler)
    },
    
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },

        globalClickHandler() {
            this.isOpen = false
        }
    }
}
</script>